<script lang="ts">
  import MainLayout from "../../layout/MainLayout.svelte";
</script>

<MainLayout>
  <h2>Sorry, page not found!</h2>
</MainLayout>
